import React from "react";
import { XCircle } from "lucide-react";
import { ScrollArea } from "@shadcn-in-nx/ui/scroll-area";
import { useTranslation } from "react-i18next";
import StatusBadge from "./StatusBadge";

function ModalOverviewTab({ execution, effectiveStatus, formatDuration }) {
    const { t } = useTranslation();

    return (
        <ScrollArea className="h-full pr-6">
            <div className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="space-y-4">
                        <div>
                            <h3 className="font-medium text-sm text-gray-500 mb-2">
                                {t("monitoring.modal.workflowName")}
                            </h3>
                            <p className="text-lg font-semibold">{execution.workflowName}</p>
                        </div>
                        <div>
                            <h3 className="font-medium text-sm text-gray-500 mb-2">
                                {t("monitoring.modal.application")}
                            </h3>
                            <p className="text-base">{execution.appName}</p>
                        </div>
                        {execution.workflowDescription && (
                            <div>
                                <h3 className="font-medium text-sm text-gray-500 mb-2">
                                    {t("monitoring.modal.description")}
                                </h3>
                                <p className="text-gray-700 text-sm leading-relaxed">
                                    {execution.workflowDescription}
                                </p>
                            </div>
                        )}
                        <div>
                            <h3 className="font-medium text-sm text-gray-500 mb-2">
                                {t("monitoring.modal.status")}
                            </h3>
                            <StatusBadge status={effectiveStatus} />
                        </div>
                    </div>
                    <div className="space-y-4">
                        <div>
                            <h3 className="font-medium text-sm text-gray-500 mb-2">
                                {t("monitoring.modal.started")}
                            </h3>
                            <p className="text-base">{new Date(execution.startedAt).toLocaleString()}</p>
                        </div>
                        {execution.completedAt && (
                            <div>
                                <h3 className="font-medium text-sm text-gray-500 mb-2">
                                    {t("monitoring.modal.completed")}
                                </h3>
                                <p className="text-base">
                                    {new Date(execution.completedAt).toLocaleString()}
                                </p>
                            </div>
                        )}
                        <div>
                            <h3 className="font-medium text-sm text-gray-500 mb-2">
                                {t("monitoring.modal.duration")}
                            </h3>
                            <p className="text-base">
                                {formatDuration(execution.startedAt, execution.completedAt)}
                            </p>
                        </div>
                        <div>
                            <h3 className="font-medium text-sm text-gray-500 mb-2">
                                {t("monitoring.modal.stepsCompleted")}
                            </h3>
                            <p className="text-base">{execution.stepExecutionsCount} {t("monitoring.modal.steps")}</p>
                        </div>
                    </div>
                </div>
                {execution.error && (
                    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                        <h3 className="font-medium text-red-800 mb-2 flex items-center gap-2">
                            <XCircle className="h-4 w-4" />
                            {t("monitoring.modal.errorInfo")}
                        </h3>
                        <p className="text-red-700 text-sm leading-relaxed">{execution.error}</p>
                    </div>
                )}
            </div>
        </ScrollArea>
    );
}

export default ModalOverviewTab;
